import nameConfigSettings from '@/components/inspectors/nameConfigSettings';
import { startEventDiameter } from './startEventConfig';
import advancedAccordionConfig from '@/components/inspectors/advancedAccordionConfig';
import documentationAccordionConfig from '@/components/inspectors/documentationAccordionConfig';
import rules from '@/mixins/ilios_functions.js'

export default {
  bpmnType: 'bpmn:StartEvent',
  control: false,
  category: 'BPMN',
  diagram(moddle) {
    return moddle.create('bpmndi:BPMNShape', {
      bounds: moddle.create('dc:Bounds', {
        height: startEventDiameter,
        width: startEventDiameter,
        x: null,
        y: null,
      }),
    });
  },
  /**
   * Validate whether to accept an incoming flow from the node
   *
   * @param node
   */
  validateIncoming() {
    return false;
  },
  inspectorConfig: [
    {
      items: [
        {
          component: 'FormAccordion',
          container: true,
          config: {
            initiallyOpen: true,
            label: 'Configuration',
            icon: 'cog',
            name: 'inspector-accordion-start-event',
          },
          items: [
            {
              component: 'FormInput',
              config: nameConfigSettings,
            },
          ],
        },
        documentationAccordionConfig,
        advancedAccordionConfig,
      ],
    },
  ],
  //.:Ilios Sistemas:.//
  rules(nodesInCanvas){
    let findNode = nodesInCanvas.find(el => el.definition.$type === this.bpmnType)
    if (findNode){
      return {
        result: false, 
        message: 'Só é permitido um node do tipo "Iniciar Evento" no workflow.'
      }
    }
    return {result: true}
  },
  exitRules(genericFlow){
    let result = []
    let findError
    result.push(rules.oneExitConector(genericFlow))
    findError = result.find(el => el.result === false)
    if (findError){
      return findError
    } else {
      return {result: true}
    }
  },
};
